// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y7cr","clinicsSelect":"styles_clinicsSelect__2d-AZ"};